import {useCallback, useMemo} from "react";

import {useOfferPagePromotionTrackingIds} from "../../promotion/hooks/use_offer_page_promotion_tracking_ids";
import {getAmplitudeOfferPagePromotionTrackingContext} from "../../promotion/tracking/get_amplitude_offer_page_promotion_tracking_context";
import {trackAmplitudeOfferSelectPromotion} from "../../promotion/tracking/track_amplitude_offer_promotion_events";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {getAmplitudeCtaLeadFormTrackingContext} from "../tracking/amplitude/get_amplitude_cta_lead_form_tracking_context";
import {ApplicationModalOpenTrackingInput} from "../types/lead/IApplicationModalOpenTracking";
import {ApplicationSource, ApplicationSourceSection} from "../utils/form/application_form_source";
import {useApplicationFormPromotionInfo} from "./use_application_form_promotion_info";
import {useLeadData} from "./use_lead_data";

interface IUseApplicationModalButtonAmplitudeOpenTrackingParams {
    vendorId: number;
    offerId: number | null;
    propertyId: number | null;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    ctaText: string;
}

export const useApplicationModalButtonAmplitudeOpenTracking = (params: IUseApplicationModalButtonAmplitudeOpenTrackingParams) => {
    const {vendorId, offerId, propertyId, source, sourceSection, ctaText} = params;

    const leadData = useLeadData({
        vendorId,
        offerId: offerId ?? undefined,
        propertyId: propertyId ?? undefined
    });

    const promotion = useApplicationFormPromotionInfo();
    const promotionTrackingIds = useOfferPagePromotionTrackingIds();

    const amplitudeLeadFormTrackingContext = useMemo(
        () =>
            getAmplitudeCtaLeadFormTrackingContext({
                source,
                sourceSection,
                leadData: leadData ?? undefined,
                ctaText
            }),
        [source, sourceSection, leadData, ctaText]
    );

    const promotionCtaSelectContext = useMemo(() => {
        if (!promotion || !promotionTrackingIds) {
            return null;
        }

        return getAmplitudeOfferPagePromotionTrackingContext({
            promotion,
            offerId: promotionTrackingIds.offerId,
            propertyId: promotionTrackingIds.propertyId,
            creativeSlot: "cta_box"
        });
    }, [promotion, promotionTrackingIds]);

    const getOpenModalTracking = useCallback(
        (gtmData: IGTMEventLeadForm): ApplicationModalOpenTrackingInput => {
            if (promotionCtaSelectContext) {
                trackAmplitudeOfferSelectPromotion(promotionCtaSelectContext);
            }

            if (amplitudeLeadFormTrackingContext) {
                return {gtm: gtmData, amplitude: amplitudeLeadFormTrackingContext};
            }

            return gtmData;
        },
        [amplitudeLeadFormTrackingContext, promotionCtaSelectContext]
    );

    return {getOpenModalTracking};
};
import {useCallback, useMemo} from "react";

import {useOfferPagePromotionTrackingIds} from "../../promotion/hooks/use_offer_page_promotion_tracking_ids";
import {getAmplitudeOfferPagePromotionTrackingContext} from "../../promotion/tracking/get_amplitude_offer_page_promotion_tracking_context";
import {trackAmplitudeOfferSelectPromotion} from "../../promotion/tracking/track_amplitude_offer_promotion_events";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {getAmplitudeCtaLeadFormTrackingContext} from "../tracking/amplitude/get_amplitude_cta_lead_form_tracking_context";
import {ApplicationModalOpenTrackingInput} from "../types/lead/IApplicationModalOpenTracking";
import {ApplicationSource, ApplicationSourceSection} from "../utils/form/application_form_source";
import {useApplicationFormPromotionInfo} from "./use_application_form_promotion_info";
import {useLeadData} from "./use_lead_data";

interface IUseApplicationModalButtonAmplitudeOpenTrackingParams {
    vendorId: number;
    offerId: number | null;
    propertyId: number | null;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    ctaText: string;
}

export const useApplicationModalButtonAmplitudeOpenTracking = (params: IUseApplicationModalButtonAmplitudeOpenTrackingParams) => {
    const {vendorId, offerId, propertyId, source, sourceSection, ctaText} = params;

    const leadData = useLeadData({
        vendorId,
        offerId: offerId ?? undefined,
        propertyId: propertyId ?? undefined
    });

    const promotion = useApplicationFormPromotionInfo();
    const promotionTrackingIds = useOfferPagePromotionTrackingIds();

    const amplitudeLeadFormTrackingContext = useMemo(
        () =>
            getAmplitudeCtaLeadFormTrackingContext({
                source,
                sourceSection,
                leadData: leadData ?? undefined,
                ctaText
            }),
        [source, sourceSection, leadData, ctaText]
    );

    const promotionCtaSelectContext = useMemo(() => {
        if (!promotion || !promotionTrackingIds) {
            return null;
        }

        return getAmplitudeOfferPagePromotionTrackingContext({
            promotion,
            offerId: promotionTrackingIds.offerId,
            propertyId: promotionTrackingIds.propertyId,
            creativeSlot: "cta_box"
        });
    }, [promotion, promotionTrackingIds]);

    const getOpenModalTracking = useCallback(
        (gtmData: IGTMEventLeadForm): ApplicationModalOpenTrackingInput => {
            if (promotionCtaSelectContext) {
                trackAmplitudeOfferSelectPromotion(promotionCtaSelectContext);
            }

            if (amplitudeLeadFormTrackingContext) {
                return {gtm: gtmData, amplitude: amplitudeLeadFormTrackingContext};
            }

            return gtmData;
        },
        [amplitudeLeadFormTrackingContext, promotionCtaSelectContext]
    );

    return {getOpenModalTracking};
};
